
$( document ).ready(function() {
$('#ProductSelect-cholesteroloz1a-option-0>div:first-child label').html('3 Pack<br/><em>(for 1x daily)</em>');
$('#ProductSelect-cholesteroloz1a-option-0>div:last-child label').html('6 Pack<br/><em>(for 2x daily)</em>');
$('#ProductSelect-cholesteroloz1a-option-0>div:last-child').append('<span class="nfs-best-saving">Best Value</span>');
$('#AddToCartForm-cholesteroloz1a input[name="purchaseType"][value="purchaseTypeSubscription"]').next().remove();
$('#AddToCartForm-cholesteroloz1a input[name="purchaseType"][value="purchaseTypeSubscription"]').after('<div class="lpso-buya">Subscribe & Save<div>Save 40% </div></div><div class="lpso-buyb"><span id="one_time_price" class="rtx_strike" > $90.00</span><span id="sub_price" class="sub_price igPrice">$54.00</span></div>');
$('#AddToCartForm-cholesteroloz2a input[name="purchaseType"][value="purchaseTypeSubscription"]').next().remove();
$('#AddToCartForm-cholesteroloz2a input[name="purchaseType"][value="purchaseTypeSubscription"]').after('<div class="lpso-buya">Subscribe & Save<div>Save 40% </div></div><div class="lpso-buyb"><span id="one_time_price" class="rtx_strike" > $99.00</span><span id="sub_price" class="sub_price igPrice">$59.40</span></div>');

$('#AddToCartForm-cholesteroloz1a input[name="purchaseType"][value="purchaseTypeOneTime"]').next().remove();
$('#AddToCartForm-cholesteroloz1a input[name="purchaseType"][value="purchaseTypeOneTime"]').after('<div class="lpso-buya">One-time purchase<div>Save 15% </div></div><div class="lpso-buyb"><span class="rtx_strike" > $90.00</span><span class="sub_price">$76.50</span><div class="rtxshotsubpricee">($3.19 per Dose shot)</div></div>' );
$('#AddToCartForm-cholesteroloz2a input[name="purchaseType"][value="purchaseTypeOneTime"]').next().remove();
$('#AddToCartForm-cholesteroloz2a input[name="purchaseType"][value="purchaseTypeOneTime"]').after('<div class="lpso-buya">One-time purchase<div>Save 15% </div></div><div class="lpso-buyb"><span class="rtx_strike" > $99.00</span><span class="sub_price">$84.15</span><div class="rtxshotsubpricee">($3.51 per Dose shot)</div></div>' );

});


$(document).ready(function(){
setTimeout(function(){
//       $('.rc_label__onetime').html('One-time purchase: <b>$54.00</b>');
$('#AddToCartForm-cholesteroloz1a .sub_percent').text('(40%)');
$('#AddToCartForm-cholesteroloz1a input[name="purchaseType"][value="purchaseTypeSubscription"] .sub_price').text('$54.00');
$('#AddToCartForm-cholesteroloz1a .sub_price').removeAttr("data-rtx-subscription-price");
$('#AddToCartForm-cholesteroloz1a .rtx_strike').removeAttr("data-rtx-onetime-price");
$('#AddToCartForm-cholesteroloz2a .sub_price').removeAttr("data-rtx-subscription-price");
$('#AddToCartForm-cholesteroloz2a .rtx_strike').removeAttr("data-rtx-onetime-price");
$('#AddToCartForm-cholesteroloz1a .sub_percent').attr("id","subpercent");
$('#AddToCartForm-cholesteroloz2a .sub_percent').attr("id","subpercent");

$('#AddToCartForm-cholesteroloz1a .rtx-subscription>div>label:first-child .sub_price').after('<div class="rtxshotsubpricee"></div>');
$('#AddToCartForm-cholesteroloz1a .rtx-subscription>div>label:last-child #one_time_price').after('<div class="rtx-shot-one-pricee"></div>');
$('#AddToCartForm-cholesteroloz2a .rtx-subscription>div>label:first-child .sub_price').after('<div class="rtxshotsubpricee"></div>');
$('#AddToCartForm-cholesteroloz2a .rtx-subscription>div>label:last-child #one_time_price').after('<div class="rtx-shot-one-pricee"></div>');
$('#AddToCartForm-cholesteroloz1a label:first-child .rtxshotsubpricee').text('($2.25 per Dose shot)');
$('#AddToCartForm-cholesteroloz1a label:nth-child(2) .rtxshotsubpricee').text('($3.19 per Dose shot)');

$('#igPrice').remove();
}, 1000);


});
$(document).ready(function(){
setTimeout(function(){
$('.rc_label__deliver_every').after('<p class="nfs-nocomitment">No commitment, cancel anytime</p>');
}, 1000);

});

$("#ProductSelect-cholesteroloz1a-option-0>div:first-child").click(function() {
$('#purchaseTypeSubscription-14653054910827---AddToCartForm-cholesteroloz1a').click();
setTimeout(function(){     
$('#AddToCartForm-cholesteroloz1a label:first-child .sub_percent').text('(40%)');
$('#AddToCartForm-cholesteroloz1a label:first-child .sub_price').text('$54.00');
$('#AddToCartForm-cholesteroloz1a label:nth-child(2)  .sub_price').text('$76.50');
$('#AddToCartForm-cholesteroloz1a label:first-child .rtxshotsubpricee').text('($2.25 per Dose shot)');
$('#AddToCartForm-cholesteroloz1a label:nth-child(2) .rtxshotsubpricee').text('($3.19 per Dose shot)');
$('#AddToCartForm-cholesteroloz1a .rtx_strike').text('$90.00');
$('.sub_price').removeAttr("data-rtx-subscription-price");
$('#AddToCartForm-cholesteroloz1a .rtx_strike').removeAttr("data-rtx-onetime-price");
  $('.rtx-subscription>div>label:first-child').click();

}, 100);
});    

$("#ProductSelect-cholesteroloz1a-option-0>div:last-child").click(function() {
$('#purchaseTypeSubscription-14653054910827---AddToCartForm-cholesteroloz1a').click();
setTimeout(function(){     
$('#AddToCartForm-cholesteroloz1a label:first-child .sub_percent').text('(40%)');
$('#AddToCartForm-cholesteroloz1a label:first-child  .sub_price').text('$96.00');
$('#AddToCartForm-cholesteroloz1a label:nth-child(2)  .sub_price').text('$136.00');
$('.sub_price').removeAttr("data-rtx-subscription-price");
$('#AddToCartForm-cholesteroloz1a .rtx_strike').text('$160.00');
$('#AddToCartForm-cholesteroloz1a .rtx_strike').removeAttr("data-rtx-onetime-price");
$('#AddToCartForm-cholesteroloz1a label:first-child .rtxshotsubpricee').text('($2.00 per Dose shot)');
$('#AddToCartForm-cholesteroloz1a label:nth-child(2) .rtxshotsubpricee').text('($2.83 per Dose shot)');
  $('.rtx-subscription>div>label:first-child').click();
}, 100);
});
$(".rtx-subscription>div>label:last-child").click(function() {

$('#igPrice').remove();
});


jQuery('.pr-img img').click(function() {
var thissrc = jQuery(this).attr('data-src');
jQuery('.main-pr').attr('src', thissrc);
jQuery('.pr-img img').removeClass('activepr');
jQuery(this).addClass('activepr');
});


jQuery('.oztab>span:first-child').click(function() {
$(this).addClass('active');
$('.oztab>span:last-child').removeClass('active');
$('#AddToCartForm-cholesteroloz1a').show();
$('#AddToCartForm-cholesteroloz2a').hide();
$('.oz1a6-img1').show();
$('.oz2a-img1').hide();
$('#AddToCartForm-cholesteroloz1a label:first-child .sub_percent').text('(40%)');
$('#AddToCartForm-cholesteroloz1a label:first-child .sub_price').text('$54.00');
$('#AddToCartForm-cholesteroloz1a label:nth-child(2)  .sub_price').text('$76.50');
$('#AddToCartForm-cholesteroloz1a label:first-child .rtxshotsubpricee').text('($2.25 per Dose shot)');
$('#AddToCartForm-cholesteroloz1a label:nth-child(2) .rtxshotsubpricee').text('($3.19 per Dose shot)');
$('#AddToCartForm-cholesteroloz1a .rtx_strike').text('$90.00');
$('.sub_price').removeAttr("data-rtx-subscription-price");
$('#AddToCartForm-cholesteroloz1a .rtx_strike').removeAttr("data-rtx-onetime-price");
setTimeout(function(){ 
$("#ProductSelect-cholesteroloz1a-option-0>div:first-child label").click();
}, 10);

});

jQuery('.oztab>span:last-child').click(function() {
$(this).addClass('active');
$('.oztab>span:first-child').removeClass('active');
$('#AddToCartForm-cholesteroloz1a').hide();
$('#AddToCartForm-cholesteroloz2a').show();
$('.oz1a6-img1').hide();
$('.oz2a-img1').show();
  $('#cozcs').hide();
  $('#AddToCartForm-cholesteroloz2a label:first-child .rtxshotsubpricee').text('($2.48 per Dose shot)');
$('#AddToCartForm-cholesteroloz2a label:nth-child(2) .rtxshotsubpricee').text('($3.51 per Dose shot)');
});



jQuery('.oztab1>span:first-child').click(function() {
$(this).addClass('active');
$('.oztab1>span:last-child').removeClass('active');
$('#AddToCartForm-cholesteroloz3').show();
$('#AddToCartForm-cholesteroloz4').hide();
$('.oz1a6-img2').show();
$('.oz2a-img2').hide();
});

jQuery('.oztab1>span:last-child').click(function() {
$(this).addClass('active');
$('.oztab1>span:first-child').removeClass('active');
$('#AddToCartForm-cholesteroloz3').hide();
$('#AddToCartForm-cholesteroloz4').show();
$('.oz1a6-img2').hide();
$('.oz2a-img2').show();
setTimeout(function(){  
  $('#AddToCartForm-cholesteroloz2a input[name="purchaseType"][value="purchaseTypeOneTime"]').after('<div class="lpso-buya">One-time purchase<div>Save 15% </div></div><div class="lpso-buyb"><span class="rtx_strike" > $99.00</span><span class="sub_price">$84.15</span></div>' );
$('#AddToCartForm-cholesteroloz2a label:first-child .rtxshotsubpricee').text('($2.48 per Dose shot)');
$('#AddToCartForm-cholesteroloz2a label:nth-child(2) .rtxshotsubpricee').text('($3.50 per Dose shot)');
$('#AddToCartForm-cholesteroloz2a label:nth-child(1) .sub_price').text('$59.40');
$('#AddToCartForm-cholesteroloz2a label:nth-child(2) .sub_price').text('$84.15');
}, 100);
});


jQuery('.pr-img img').click(function() {
var thissrc = jQuery(this).attr('src');
jQuery('.main-pr').attr('src', thissrc);
jQuery('.pr-img img').removeClass('activepr');
jQuery(this).addClass('activepr');

});

jQuery('.pr-img2 img').click(function() {
var thissrc = jQuery(this).attr('src');
jQuery('.main-pr2').attr('src', thissrc);
jQuery('.pr-img2 img').removeClass('activepr');
jQuery(this).addClass('activepr');
});

jQuery('.pr-img1 img').click(function() {
var thissrc = jQuery(this).attr('src');
jQuery('.main-pr1').attr('src', thissrc);
jQuery('.pr-img1 img').removeClass('activepr');
jQuery(this).addClass('activepr');
});

jQuery('.pr-img4 img').click(function() {
var thissrc = jQuery(this).attr('src');
jQuery('.main-pr4').attr('src', thissrc);
jQuery('.pr-img4 img').removeClass('activepr');
jQuery(this).addClass('activepr');
});
$(document).ready(function(){
setTimeout(function(){
$('.nfs-nocomitment').html('<ul><li>Save 15% off recurring orders</li><li>No commitments</li><li>30-day money-back guarantee</li></ul>');
}, 2000);
});


          
           

          
           
            jQuery('.lpsoplusclick').click(function() {
$(this).toggleClass('active');
if ($(this).text() == "+")
  {     
  $(this).text("-")
            }  
else
 {
    $(this).text("+");
}
$(this).prev('.lpso-ig_box_popup').toggle();

});


